<template>
    <view-with-bar>
        <template slot="bar">
            <view-bar>
                <view-bar-header :actions="headerActions" @add="handleAdd">Dashboards</view-bar-header>
                <view-bar-item v-for="dashboard in dashboards" :route="`/dashboards/view/${dashboard.id}`"
                               @edit="() => $router.push(`/dashboards/edit/${dashboard.id}`)" :actions="dashboardActions">{{dashboard.displayName}}</view-bar-item>
            </view-bar>
        </template>
    </view-with-bar>
</template>

<script>
    import ViewWithBar from "../components/layout/ViewWithBar";
    import ViewBarItem from "../components/navigation/ViewBarItem";
    import ViewBar from "../components/navigation/ViewBar";
    import ViewBarHeader from "../components/navigation/ViewBarHeader";
    import {mapGetters} from "vuex";

    export default {
        name: "DashboardView",
        components: {
            ViewBarHeader,
            ViewBar, ViewBarItem, ViewWithBar },
        data() {
            return {
                headerActions: [{name: 'add', icon: 'plus-circle'}],
                dashboardActions: [{name: 'edit', icon: 'edit'}]
            }
        },
        mounted() {
            //this.$store.dispatch("banking/refreshAllBalances")
        },
        methods: {
            handleAdd() {
                this.$router.push("/dashboards/edit/new")
            }
        },
        computed: {
            ... mapGetters({"dashboards": "dashboards/dashboards"})
        }
    }
</script>

<style lang="scss" scoped>

</style>